import { useMutation } from '@apollo/client';
import { GRAPHQL_CONFIGURACOES_UNIDADE_PARAMETROS } from 'gql/unidade';
import { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from 'routes/auth.context';
export const useMutateUnidadeParametros = () => {
    const history = useHistory();
    const { alertConfirm } = useContext(AuthContext);
    const [handleUpdate, { loading }] = useMutation(
        GRAPHQL_CONFIGURACOES_UNIDADE_PARAMETROS
    );
    const atualizaUnidadeConfiguracoesParametros = useCallback(
        async ({ unidadeId, data }) => {
            try {
                await handleUpdate({
                    variables: {
                        unidadeId,
                        data,
                    },
                });
                history.goBack();
            } catch ({ message }: any) {
                await alertConfirm({
                    tipo: 'erro',
                    titulo: 'Erro',
                    conteudo: message as string,
                });
            }
        },
        []
    );
    return {
        atualizaUnidadeConfiguracoesParametros,
        loading,
    };
};
